import {
  collection,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";

import { db } from "../firebase/firebase";
import { resolveWebsiteCatalogItem } from "./catalogImageVariants";

export function listenToGarmentsBySection(
  sectionId,
  onSuccess,
  onError
) {
  if (!sectionId) {
    onSuccess([]);
    return () => {};
  }

  const garmentsQuery = query(
    collection(db, "garments"),
    where("sectionId", "==", sectionId),
    where("isActive", "==", true),
    orderBy("displayOrder", "asc")
  );

  return onSnapshot(
    garmentsQuery,
    (snapshot) => {
      const garments = snapshot.docs.map((document) =>
        resolveWebsiteCatalogItem({
          id: document.id,
          ...document.data(),
        })
      );

      onSuccess(garments);
    },
    onError
  );
}
